'use strict';

bbw.directive.bbwPristineOn = ['$timeout', function($timeout) {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
            var eventName = attrs.bbwPristineOn;
            if (eventName) {
                scope.$on(eventName, function() {
                    $timeout(function() {
                        ngModel.$setPristine();
                    });
                });
            }
        }
    };
}];
